import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import ClickAwayListener from '@material-ui/core/ClickAwayListener'
import Tooltip from '@material-ui/core/Tooltip'
import cs from 'classnames'
import classNames from 'classnames'

const useStyles = makeStyles(theme => ({
    iconButton: {
        margin: '0 25px 0 5px'
    },
    tooltip: {
        /* backgroundColor: theme.tooltipBackground,
        color: theme.tooltipFont */
        opacity: 1
    },
    contentWrapper: {
        display: 'flex',
        alignItems: 'center'
    },
    popperWrapper: {
        maxWidth: 300,
        fontSize: 12,
        padding: 5,
        fontWeight: 'bold',
        fontFamily: theme.fontFamily,
        lineHeight: 1.3
        // backgroundColor: theme.tooltipBackground
    }
}))

export default function CustomTooltip({
    wrapperClass,
    hover,
    text,
    placement,
    hideTooltip,
    tooltipClass,
    children,
    enterDelay
}) {
    const classes = useStyles()

    const [open, setOpen] = useState(false)

    const getTooltipContent = () => {
        if (typeof children !== 'undefined') {
            return (
                <div
                    className={cs([classes.contentWrapper, wrapperClass])}
                    onClick={!hover ? setOpen.bind(this, true) : () => {}}
                >
                    {children}
                </div>
            )
        } else {
            return (
                <span
                    className={classes.iconButton}
                    style={{ cursor: hover ? 'default' : 'pointer' }}
                    onClick={hover ? () => {} : setOpen.bind(this, true)}
                    onMouseOver={hover ? setOpen.bind(this, true) : () => {}}
                    onMouseOut={hover ? setOpen.bind(this, false) : () => {}}
                >
                    ⓘ
                </span>
            )
        }
    }

    return (
        <ClickAwayListener onClickAway={setOpen.bind(this, false)}>
            <React.Fragment>
                {hideTooltip && getTooltipContent()}
                {!hideTooltip && (
                    <Tooltip
                        enterDelay={enterDelay ? enterDelay : undefined}
                        onClose={setOpen.bind(this, false)}
                        interactive={!!hover}
                        open={hover ? undefined : open}
                        disableFocusListener={!hover}
                        disableHoverListener={!hover}
                        disableTouchListener={!hover}
                        classes={{
                            tooltip: classNames([classes.tooltip, tooltipClass])
                        }}
                        title={
                            text ? (
                                <div className={classes.popperWrapper}>
                                    {text}
                                </div>
                            ) : (
                                ''
                            )
                        }
                        placement={placement}
                    >
                        {getTooltipContent()}
                    </Tooltip>
                )}
            </React.Fragment>
        </ClickAwayListener>
    )
}
